import css from "./CheckBox.module.css";

export function CheckBox(props: React.InputHTMLAttributes<HTMLInputElement> & { label?: string; }) {
  return <div className={css.group}><input id={props.id} name={props.id} type='checkbox' className={css.input} {...props} /><label className={css.label} htmlFor={props.id}>{props.label}</label></div>;
}
